import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-share-stroke-icon]',
  template: `
    <svg:path
      d="M10 2C10.5523 2 11 2.44772 11 3C11 3.55228 10.5523 4 10 4H5C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V14C20 13.4477 20.4477 13 21 13C21.5523 13 22 13.4477 22 14V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2H10ZM17.293 2.29297C17.6835 1.90244 18.3165 1.90244 18.707 2.29297L21.707 5.29297C22.0976 5.68349 22.0976 6.31651 21.707 6.70703L18.707 9.70703C18.3165 10.0976 17.6835 10.0976 17.293 9.70703C16.9024 9.31651 16.9024 8.68349 17.293 8.29297L18.5859 7H16C14.8954 7 14 7.89543 14 9V12C14 12.5523 13.5523 13 13 13C12.4477 13 12 12.5523 12 12V9C12 6.79086 13.7909 5 16 5H18.5859L17.293 3.70703C16.9024 3.31651 16.9024 2.68349 17.293 2.29297Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShareStrokeIcon {
  readonly viewBox = input<string>('0 0 24 24');
}
